import styled from "styled-components";

export const CreateContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 20px;
  gap: 40px;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px 10px 30px;
  position: relative;
  flex: 1;
`

export const TitleBig = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: ${({theme}) => theme.palette[850]};
  margin: 20px 0;
`

export const FormWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`

export const Info = styled.div`
  background: ${({theme}) => theme.grey[100]};
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
`

export const InfoText = styled.p`
  font-size: 14px;
  color: ${({theme}) => theme.palette[650]};
  line-height: 1.5;
  margin: 0;
`

export const DarkForm = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  margin-bottom: 10px;
`
